<template>
  <div class="prov-accordion">
    <button type="button" class="prov-header" @click="$emit('toggle')">
      <i class="chevron" :class="expanded ? 'ri-arrow-down-s-line' : 'ri-arrow-right-s-line'"></i>
      <span class="prov-name">{{ titleCase(province.name) }}</span>
      <span class="prov-count">({{ province.total_districts }} distritos)</span>
      <span class="prov-badge badge" :class="withoutPrice > 0 ? 'badge-yellow' : 'badge-green'">
        {{ withoutPrice > 0 ? `${withoutPrice} sin precio` : `${withPrice} con precio` }}
      </span>
    </button>

    <!-- custom-form habilita el estilo de custom-form-control en las celdas -->
    <div v-show="expanded" class="prov-body custom-form">
      <div class="table-responsive mb-0">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="col-district text-left">Distrito</th>
              <th v-for="vt in vehicleTypes" :key="vt" class="col-price">{{ vt }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in visibleDistricts" :key="d.district_id">
              <td class="col-district">
                <span class="ubigeo">{{ d.ubigeo_inei || '—' }}</span>
                <span class="dname" v-html="highlight(d.name)"></span>
              </td>
              <td v-for="vt in vehicleTypes" :key="vt" class="col-price">
                <PriceCell
                  :district-id="d.district_id"
                  :vehicle-type="vt"
                  :route-type="routeType"
                  :value="priceOf(d, vt)"
                  :sprinter="vt === 'Sprinter'"
                  @saved="$emit('saved', $event)"
                />
              </td>
            </tr>
            <tr v-if="!visibleDistricts.length">
              <td :colspan="vehicleTypes.length + 1" class="text-center text-muted py-3">
                Sin distritos que coincidan.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import PriceCell from './PriceCell.vue'

export default {
  name: 'ProvinceAccordion',
  components: { PriceCell },
  props: {
    province: { type: Object, required: true }, // { name, total_districts, districts[] }
    expanded: { type: Boolean, default: false },
    vehicleTypes: { type: Array, required: true },
    routeType: { type: String, required: true },
    search: { type: String, default: '' }
  },
  computed: {
    withPrice() {
      return this.province.districts.filter((d) => this.hasPrice(d)).length
    },
    withoutPrice() {
      return this.province.districts.length - this.withPrice
    },
    visibleDistricts() {
      const q = this.search.trim().toLowerCase()
      if (!q) return this.province.districts
      return this.province.districts.filter((d) => d.name.toLowerCase().includes(q))
    }
  },
  methods: {
    titleCase(s) {
      if (!s) return ''
      return String(s).toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    },
    hasPrice(d) {
      return d.prices && Object.keys(d.prices).length > 0
    },
    priceOf(d, vt) {
      return d.prices && d.prices[vt] != null ? d.prices[vt] : null
    },
    highlight(name) {
      const esc = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      const q = this.search.trim()
      if (!q) return esc(name)
      const i = name.toLowerCase().indexOf(q.toLowerCase())
      if (i < 0) return esc(name)
      return esc(name.slice(0, i)) + '<mark>' + esc(name.slice(i, i + q.length)) + '</mark>' + esc(name.slice(i + q.length))
    }
  }
}
</script>

<style lang="stylus" scoped>
.prov-accordion
  border 1px solid #e5e7eb
  border-radius 8px
  margin-bottom 10px
  overflow hidden
.prov-header
  width 100%
  display flex
  align-items center
  gap 10px
  padding 12px 14px
  background #f7f8fa
  border none
  cursor pointer
  text-align left
  .chevron
    font-size 18px
    color #6c757d
  .prov-name
    font-weight 600
    font-size 14px
  .prov-count
    font-size 12px
    color #6c757d
  // El badge de completitud usa las clases del sistema (badge-green /
  // badge-yellow); aquí solo se empuja a la derecha.
  .prov-badge
    margin-left auto
.prov-body
  padding 0
.custom-table
  .col-price
    width 130px
  td.col-price
    padding-top 7px
    padding-bottom 7px
  .col-district
    width 220px
    vertical-align middle
    .ubigeo
      font-size 11px
      color #adb5bd
      margin-right 8px
    .dname
      font-size 13px
</style>
